/* @flow */

// eslint-disable-next-line import/no-namespace
import * as INTERFACE from './interface';

export * from './interface';
export default INTERFACE;



// WEBPACK FOOTER //
// webpack://paypal/node_modules/zoid/src/index.js